module.exports = __webpack_public_path__ + "static/media/address4.4b19eb15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/andimar/favoriteDestinations/address4.jpg
// module id = 700
// module chunks = 0